import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { UserRegistrationService } from 'src/app/services/local/user-registration-manager.service';

@Component({
    selector: 'app-contact-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.scss'],
    standalone: false
})
export class ContactInfoComponent implements OnInit {

  constructor(private _userRegistrationService: UserRegistrationService,
              private _localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    const empRef = this._localStorageService.getRegEmployee();
    if (!empRef) {
      this._userRegistrationService.showMissingAccountInfoMessage();
    }
  }
}
